import React from 'react'

const images = [
    "/events/ATMOSPHERE.jpg",
    "/events/giornogdl.jpg",
    "/events/giornocuu.jpg",
    "/events/klipsun.jpg",
    "/events/yuri.jpg",
    "/events/vegas.jpg",
];

export default function GalleryLatest() {
    return (
        <div className="bg-[#0a0a0f] py-16 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10">
                    <span className="text-brand font-mono font-semibold text-sm uppercase tracking-widest">Galería</span>
                    <h2 className="text-white font-display font-bold text-3xl sm:text-4xl mt-2">Últimos Eventos</h2>
                </div>
                <div className="columns-2 md:columns-3 lg:columns-4 gap-3">
                    {images.map((src, index) => (
                        <div key={src} className="break-inside-avoid mb-3 overflow-hidden rounded-xl group">
                            <img
                                src={src}
                                alt={`Evento ${index + 1}`}
                                loading="lazy"
                                decoding="async"
                                className="w-full rounded-xl shadow-lg group-hover:scale-105 transition-transform duration-500 object-cover"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
